import React from 'react';
import { Zap, Wallet, FileText, BarChart3, Shield, MessageCircle } from 'lucide-react';
import { features } from '../mockData';
import { useLanguage } from '../context/LanguageContext';

const iconMap = {
  Zap,
  Wallet,
  FileText,
  BarChart3,
  Shield,
  MessageCircle
};

const Features = () => {
  const { t } = useLanguage();
  
  return (
    <section style={{
      padding: '120px 24px',
      background: 'var(--bg-secondary)',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {/* Section Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '80px'
        }}>
          <h2 style={{
            fontSize: '48px',
            fontWeight: 700,
            marginBottom: '16px',
            color: 'var(--text-primary)'
          }} className="display-md">
            {t('features.title')}
          </h2>
          <p style={{
            fontSize: '18px',
            color: 'var(--text-secondary)',
            maxWidth: '700px',
            margin: '0 auto'
          }} className="body-lg">
            {t('features.subtitle')}
          </p>
        </div>

        {/* Features Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '32px'
        }}>
          {features.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                style={{
                  background: 'var(--bg-primary)',
                  border: '1px solid var(--border-subtle)',
                  borderRadius: '20px',
                  padding: '40px',
                  transition: 'all 0.3s ease'
                }}
                className="card hover-lift"
              >
                {/* Icon */}
                <div style={{
                  width: '64px',
                  height: '64px',
                  background: 'linear-gradient(135deg, rgba(14, 165, 233, 0.2) 0%, rgba(14, 165, 233, 0.05) 100%)',
                  borderRadius: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--accent-blue)',
                  marginBottom: '24px'
                }}>
                  <IconComponent size={32} />
                </div>

                {/* Title */}
                <h3 style={{
                  fontSize: '24px',
                  fontWeight: 600,
                  marginBottom: '16px',
                  color: 'var(--text-primary)'
                }} className="h3">
                  {feature.title}
                </h3>

                {/* Description */}
                <p style={{
                  fontSize: '16px',
                  lineHeight: 1.7,
                  color: 'var(--text-muted)'
                }} className="body-md">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;